import { cn } from "@/lib/utils";
import AppLogoIcon from "./app-logo-icon";
import AppLogoText from "./app-logo-text";

type AppLogoProps = {
  name: string;
  showLogoText?: boolean;
  size?: keyof typeof sizes;
  className?: string;
};

const sizes = {
  sm: "sm",
  md: "md",
  lg: "lg",
} as const;

const appLogoIconSize = {
  [sizes.sm]: "size-4",
  [sizes.md]: "size-5",
  [sizes.lg]: "size-6",
} as const;

const appLogoTextSize = {
  [sizes.sm]: "h-4",
  [sizes.md]: "h-5",
  [sizes.lg]: "h-6",
} as const;

const appLogoGap = {
  [sizes.sm]: "gap-1.25",
  [sizes.md]: "gap-1.5",
  [sizes.lg]: "gap-1.75",
} as const;

/**
 * Application logo component that displays the app icon alongside the application name
 */
export default function AppLogo({
  name,
  showLogoText = true,
  size = "sm",
  className,
}: AppLogoProps) {
  const defaultClassName = cn(
    "fill-current text-black dark:text-white",
    className
  );

  return (
    <div className={cn("flex items-start", appLogoGap[size])}>
      <AppLogoIcon
        aria-hidden="true"
        className={cn(defaultClassName, appLogoIconSize[size])}
        name={name}
      />
      <AppLogoText
        aria-hidden="true"
        className={cn(defaultClassName, appLogoTextSize[size])}
        name={name}
        showLogoText={showLogoText}
      />
      <span className="sr-only">{name}</span>
    </div>
  );
}
